import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

const actionMap = {
  SKIP_LONG_TRIGGER: 'System will skip long trigger.',
  SKIP_SHORT_TRIGGER: 'System will skip short trigger.',
  WAIT_FOR_NEXT_CANDLE: 'System will wait for the next candle.',
  CREATE_BOUNCE_TRIGGER: 'System will create a bounce trigger.',
  TERMINATE_TRADE_PLAN: 'System will terminate trade plan.',
};
export function priceFiltersTriggerCandleBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Candle trigger filtered out by current price. Current price:{' '}
        {parsedStatusObj.price
          ? '$' + ApplyRounding(Number(parsedStatusObj.price), 2)
          : 'unknown'}
        . {parsedStatusObj.action ? actionMap[parsedStatusObj.action] : ''}
      </Body3>
    </td>
  );
}
